const IncorrectLink = {
    title: "Некорректная ссылка",
    message: "Обратитесь к представителю компании Сибур для получения корректной ссылки"
  };

const ExpiredLink = {
    title: "Истёк срок действия ссылки",
    message: "Обратитесь к представителю компании Сибур для получения действующей ссылки"
  };

const InternalServerError = {
    title: "Внутренняя ошибка сервера"
  };

const SendingError = {
  title: "Внутренняя ошибка сервера",
  message: "Произошла ошибка при попытке запустить обработку пакета"
}

export default {
    IncorrectLink,
    ExpiredLink,
    InternalServerError,
    SendingError
}